export default __webpack_public_path__ + "static/media/nomady-social-media-mountain-1200x630.d7063911.jpg";